import { useState } from "react";
import { Col, Row } from "react-bootstrap";

const ProcurementManagement = () => {
  const [selected, setSelected] = useState("Spend Analysis");

  const handleClick = (item) => {
    setSelected(item);
  };
  return (
    <>
      <div className="container d-flex justify-content-center mt-5 promng">
        <Row>
          <Col xl={6} md={6} lg={6} className="text-end ">
            <p
              onClick={() => handleClick("Spend Analysis")}
              className={`${selected === "Spend Analysis" ? "active" : ""}`}
            >
              Spend Analysis
              <img
                className="promeimg"
                src="./assets/ProcurementManagement/spend-analysis-ico.svg"
                alt="logo"
              />
            </p>
            <p
              onClick={() => handleClick("Saving Tracking")}
              className={selected === "Saving Tracking" ? "active" : ""}
            >
              Saving Tracking
              <img
                className="promeimg"
                src="./assets/ProcurementManagement/savings-tracking.svg"
                alt="logo"
              />
            </p>
            <p
              onClick={() => handleClick("Sourcing")}
              className={selected === "Sourcing" ? "active" : ""}
            >
              Sourcing
              <img
                className="promeimg"
                src="./assets/ProcurementManagement/sourcing.svg"
                alt="logo"
              />
            </p>
            <p
              onClick={() => handleClick("Contract Management")}
              className={selected === "Contract Management" ? "active" : ""}
            >
              Contract Management
              <img
                className="promeimg"
                src="./assets/ProcurementManagement/contract-management.svg"
                alt="logo"
              />
            </p>
            <p
              onClick={() => handleClick("Supplier Management")}
              className={selected === "Supplier Management" ? "active" : ""}
            >
              Supplier Management
              <img
                className="promeimg"
                src="./assets/ProcurementManagement/supplier-management.svg"
                alt="logo"
              />
            </p>
            <p
              onClick={() => handleClick("Procure-to-pay")}
              className={selected === "Procure-to-pay" ? "active" : ""}
            >
              Procure-to-pay
              <img
                className="promeimg"
                src="./assets/ProcurementManagement/procuretopay.svg"
                alt="logo"
              />
            </p>
          </Col>
          <Col xl={6} md={6} lg={6}>
            {selected === "Spend Analysis" && (
              <div className="procurement">Spend Analysis</div>
            )}
            {selected === "Saving Tracking" && (
              <div className="procurement">Saving Tracking</div>
            )}
            {selected === "Sourcing" && (
              <div className="procurement">Sourcing</div>
            )}
            {selected === "Contract Management" && (
              <div className="procurement">Contract Management</div>
            )}
            {selected === "Supplier Management" && (
              <div className="procurement">Supplier Management</div>
            )}
            {selected === "Procure-to-pay" && (
              <div className="procurement">Procure-to-pay</div>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};
export default ProcurementManagement;
